import React from 'react'
import getTextColorClass from '@bt-react/libs/getTextColorClass'
import getDateDiff from '@bt-react/libs/getDateDiff'
import classnames from 'classnames'
import { CountdownProps, CountdownState, TimeFormat } from './types'

class Countdown extends React.Component<CountdownProps, CountdownState> {

  ref

  constructor (props) {

    super(props)
    this.state = {
      hasPassed: undefined,
      timeout: null,
      tickInProgress: false,
      countdownComplete: false
    }
    this.ref = React.createRef()

  }

  componentDidMount () {

    this.setDateDiff()

  }

  componentDidUpdate (prevProps, prevState) {

    if (prevState.tickInProgress !== this.state.tickInProgress && !this.state.tickInProgress) {

      this.setDateDiff()

    }

    if (this.state.hasPassed === true && !this.state.countdownComplete) {

      this.setState({
        countdownComplete: true
      })
      this.setCountdownComplete()

    }

  }

  componentWillUnmount () {

    clearTimeout(this.state.timeout)

  }

  setCountdownComplete = () => {

    if (typeof this.props.onChange === 'function') this.props.onChange({ live: true })
    return null

  }

  setDateDiff = () => {

    this.setState({
      tickInProgress: true,
      hasPassed: getDateDiff(this.props.date).hasPassed,
      timeout: setTimeout(() => {

        if (this.ref.current !== null) {

          this.setState({
            tickInProgress: false
          })

        }

      }, 1000)
    })

  }

  getTextColor = () => {

    const { color = 'orange', overrunColor = 'orange' } = this.props
    const timerColor = this.state.hasPassed ? overrunColor : color
    return getTextColorClass(timerColor)

  }

  render () {

    if( !this.props.date ) return null
    if ( !this.props.allowMinus && this.state.hasPassed) return null

    const { countDownFormat } = this.props
    const countdownText = typeof this.props.countdownText === 'string' ? this.props.countdownText : 'LIVE IN:'

    const duration = getDateDiff(this.props.date, { allowMinus: this.props.allowMinus || false }, countDownFormat)

    const countdownClasses = classnames(
      this.props.className,
      this.getTextColor()
    )

    let dateStr = ''

    if (this.props.format === TimeFormat.CONCISE && duration.toConciseString) dateStr = duration.toConciseString()
    else if (this.props.format === TimeFormat.NUMERIC && duration.toNumeric) dateStr = duration.toNumeric()
    else if (duration.toString) dateStr = duration.toString()

    return <span
      ref={this.ref}
      data-bdd={this.props['dataBdd'] || 'countdown'}
      className={countdownClasses}
    >
      <span
        className={this.props.countdownTextClassName}
        data-bdd={`${this.props['dataBdd'] || 'countdown'}-text`}
      >{ countdownText }</span> <span
        className={this.props.countdownClassName}
        data-bdd={`${this.props['dataBdd'] || 'countdown'}-datetime`} suppressHydrationWarning>{ dateStr }
      </span>
    </span>

  }

}

export default Countdown
